import { DialogActions } from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import CreditLineStatus from 'pages/Finance/Components/Financing/common/creditLineStatus';
import React, { useState } from 'react';

import ConfirmingAssignationModule from '../../../../../Assignation/ConfirmingCreditLineAssignationModule';
import CreditCreditLineAssignationModule from '../../../../../Assignation/CreditCreditLineAssignationModule';
import FactoringCreditLineAssignationModule from '../../../../../Assignation/FactoringCreditLineAssignationModule';
import SGRCreditLineAssignationModule from '../../../../../Assignation/SGRCreditLineAssignationModule';

const ShoppingCartFactoringReviewed = (props: any) => {
  const {
    setOpenShoppingCart,
    openRequest,
    setUp,
    inAssignationDefault,
    updateStatus,
    handleDetails,
    setEditing, // Add this prop to handle returning to editing mode
  } = props;

  const [inAssignation, setInAssignation] = useState(
    inAssignationDefault ? true : false,
  );

  const hanldeAssignation = async () => {
    setInAssignation(true);
  };

  // Handle cancel from assignment module - if we're in editing mode, go back to editing
  const handleCancelFromAssignment = () => {
    if (inAssignationDefault && setEditing) {
      setEditing(false); // Return to ShoppingCartFactoringAlive
    } else {
      setInAssignation(false); // Normal flow - go back to "Asignar" view
    }
  };

  return (
    <div>
      <div>
        {inAssignation ? (
          <div>
            {openRequest.productName === 'Factoring' && (
              <FactoringCreditLineAssignationModule
                setOpenShoppingCart={setOpenShoppingCart}
                openRequest={openRequest}
                updateStatus={updateStatus}
                setInAssignation={setInAssignation}
                setUp={setUp}
                handleDetails={handleDetails}
                onCancel={handleCancelFromAssignment}
                isEditingMode={inAssignationDefault}
              />
            )}
            {openRequest.productName === 'Créditos' && (
              <CreditCreditLineAssignationModule
                setOpenShoppingCart={setOpenShoppingCart}
                openRequest={openRequest}
                updateStatus={updateStatus}
                setInAssignation={setInAssignation}
                setUp={setUp}
                handleDetails={handleDetails}
                onCancel={handleCancelFromAssignment}
                isEditingMode={inAssignationDefault}
              />
            )}
            {openRequest.productName === 'SGR' && (
              <SGRCreditLineAssignationModule
                setOpenShoppingCart={setOpenShoppingCart}
                openRequest={openRequest}
                updateStatus={updateStatus}
                setInAssignation={setInAssignation}
                setUp={setUp}
                handleDetails={handleDetails}
                onCancel={handleCancelFromAssignment}
                isEditingMode={inAssignationDefault}
              />
            )}
            {openRequest.productName === 'Confirming' && (
              <ConfirmingAssignationModule
                setOpenShoppingCart={setOpenShoppingCart}
                openRequest={openRequest}
                updateStatus={updateStatus}
                setInAssignation={setInAssignation}
                setUp={setUp}
                handleDetails={handleDetails}
                onCancel={handleCancelFromAssignment}
                isEditingMode={inAssignationDefault}
              />
            )}
          </div>
        ) : (
          <div>
            <CreditLineStatus
              openRequest={openRequest}
              audienceType="received"
            />
            <DialogActions>
              <CustomButton onClick={() => hanldeAssignation()} color="primary">
                Asignar
              </CustomButton>
              <CustomButton
                onClick={() => setOpenShoppingCart(false)}
                color="secondary"
              >
                Salir
              </CustomButton>
            </DialogActions>
          </div>
        )}
      </div>
    </div>
  );
};

export default ShoppingCartFactoringReviewed;
